import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface BottomNavigationProps {
  onMoreClick: () => void;
}

interface BottomTab {
  icon: string;
  label: string;
  path: string;
  activeOn: string[];
}

const BOTTOM_TABS: BottomTab[] = [
  {
    icon: 'bi-graph-up',
    label: 'Analytics',
    path: '/analytics/summary',
    activeOn: ['/analytics', '/events'],
  },
  {
    icon: 'bi-activity',
    label: 'Monitoring',
    path: '/monitoring/live',
    activeOn: ['/monitoring'],
  },
  {
    icon: 'bi-shield-lock',
    label: 'Security',
    path: '/security/ai-advisor',
    activeOn: ['/security'],
  },
  {
    icon: 'bi-server',
    label: 'Servers',
    path: '/servers',
    activeOn: ['/servers'],
  },
];

const BottomNavigation: React.FC<BottomNavigationProps> = ({ onMoreClick }) => {
  const location = useLocation();

  const isTabActive = (tab: BottomTab): boolean => {
    return tab.activeOn.some((prefix) => location.pathname.startsWith(prefix));
  };

  const isMoreActive = (): boolean => {
    const morePaths = ['/alerts', '/admin', '/integration', '/assets', '/organisation', '/users'];
    return morePaths.some((prefix) => location.pathname.startsWith(prefix));
  };

  return (
    <nav className="bottom-navigation">
      {BOTTOM_TABS.map((tab) => (
        <Link
          key={tab.path}
          to={tab.path}
          className={`bottom-nav-item ${isTabActive(tab) ? 'active' : ''}`}
        >
          <i className={`bi ${tab.icon}`}></i>
          <span>{tab.label}</span>
        </Link>
      ))}
      <button
        className={`bottom-nav-item ${isMoreActive() ? 'active' : ''}`}
        onClick={onMoreClick}
      >
        <i className="bi bi-three-dots"></i>
        <span>More</span>
      </button>
    </nav>
  );
};

export default BottomNavigation;
